export const TEMPLATES_SET = 'TEMPLATES_SET';
export const TEMPLATES_OPEN_PREVIEW = 'TEMPLATES_OPEN_PREVIEW';
export const TEMPLATES_CLOSE_PREVIEW = 'TEMPLATES_CLOSE_PREVIEW';
